import { Box, Typography } from '@mui/material';

import banner from '@assets/asas-modal.jpg';
import logoAllseg from '@assets/allseg-seguradora-azul.svg';
import logoAsasGarantia from '@assets/asas-garantia.svg';

const Banner = () => {
  return (
    <Box
      sx={{
        width: '100%',
        height: { xs: '150px', md: '223px' },
        mx: 'auto',
        boxShadow: '0px 4px 4px 0px #00000040',
        borderRadius: '12px',
        overflow: 'hidden',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        px: { xs: '24px', md: '88px' },
        gap: '20px',
        backgroundImage: `linear-gradient(rgba(255,255,255,0.7), rgba(255,255,255,0.7)), url(${banner})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <Typography
        sx={{
          fontFamily: 'Montserrat, sans-serif',
          fontWeight: 700,
          fontSize: { xs: '20px', md: '24px' },
          color: '#004AA0',
        }}
      >
        Contratação de Seguro Garantia
      </Typography>

      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'flex-start', md: 'center' },
          gap: { xs: '12px', sm: '66px' },
        }}
      >
        <Box
          component="img"
          src={logoAsasGarantia}
          alt="ASAS Garantias"
          sx={{
            height: { xs: '30px', md: '77px' },
            width: { xs: '95px', md: '249px' },
          }}
        />
        <Box
          component="img"
          src={logoAllseg}
          alt="AllSeg Seguradora"
          sx={{
            height: { xs: '37px', md: '94px' },
            width: { xs: '71px', md: '184px' },
          }}
        />
      </Box>
    </Box>
  );
};

export default Banner;
